
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import AnimateInView from '@/components/ui/animate-in-view';
import SectionHeading from '@/components/ui/section-heading';

const FibreOverview = () => {
  return (
    <section aria-labelledby="overview-heading" className="section bg-white py-[98px]">
      <div className="container mx-auto">
        <SectionHeading 
          title="What It Is"
          className="text-center mb-8"
          titleClassName="text-forti-fi-teal"
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          <AnimateInView animation="slide-up" delay={200}>
            <div>
              <p className="mb-4 text-lg text-forti-fi-charcoal">
                Our <strong>Fiber Optic In-Ground System</strong> creates an <strong>invisible fence</strong> by embedding sensor cables underground. Utilizing real-time vibration analysis and machine learning, the system identifies threats (human, animal, machinery) <em>without disrupting landscapes or infrastructure</em>.
              </p>
              <p className="mb-6 text-forti-fi-charcoal">
                The system uses <strong>Distributed Acoustic Sensing (DAS) technology</strong> to analyze vibrations and classify threats in real time, identifying humans, vehicles, digging, or fence climbs with <strong>environmental self-calibration</strong>.
              </p>
              
              <Button asChild className="text-white mt-4 bg-forti-fi-teal hover:bg-forti-fi-teal/90">
                <Link to="/contact">
                  Get Your Free Assessment <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </AnimateInView>
          <AnimateInView animation="fade-in" delay={400}>
            <div className="bg-forti-fi-lavender/20 rounded-lg overflow-hidden">
              <img alt="Fibre-Optic Technology" className="w-full h-full object-cover aspect-video" loading="lazy" src="/images/fibre-undulate.jpg" />
            </div>
          </AnimateInView>
        </div>
      </div>
    </section>
  );
};

export default FibreOverview;
